<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Movimiento de caja</h3>
      </div>
    </div>
    
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="valor_abono"
            v-model="form.valor"
            vMoney
            :format="money"
            placeholder="Escriba un valor..."
          >
            $ Valor
            <span
              v-if="errores.valor"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.valor[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              label="descripcion"
              @input="inputBodega"
              placeholder="Seleccione..."
              id="bodega_id"
              v-model="selectedBodega"
              :options="bodegas"
            ></v-select>
            <label for="bodega_id">Sucursal</label>
            <span
              v-if="errores.bodega_id"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.bodega_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <textarea-field
            placeholder="Escriba un detalle..."
            id="observacion"
            v-model="form.detalle"
          >
            <span>Detalle</span>
            <span
              v-if="errores.detalle"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.detalle[0] }}</strong>
            </span>
          </textarea-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              label="descripcion"
              @input="inputTipoGasto"
              placeholder="Seleccione..."
              id="tipo_gasto_codigo"
              v-model="selectedTipoGasto"
              :options="tiposGastos"
            ></v-select>
            <label for="tipo_gasto_codigo">Tipo de movimiento</label>
            <span
              v-if="errores.tipo_gasto_codigo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.tipo_gasto_codigo[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div v-show="selectedTipoGasto != null && selectedTipoGasto.tipo_aplicacion !== 'V'" class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              :options="personas"
              id="persona"
              name="persona"
              @input="inputPersona"
              v-model="selectedPersona"
              @search="searchPersonas"
              label="nombre"
            ></v-select>
            <label for="persona">Personas</label>
            <span
              v-if="errores.persona_id"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.persona_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div v-show="selectedTipoGasto != null && selectedTipoGasto.tipo_aplicacion === 'V'" class="col-xs-12 col-md-6">
        <div
          class="form-field select2"
        >
          <div class="select2-field">
            <v-select
              @search="searchVendedores"
              @input="inputVendedor"
              v-model="selectedVendedor"
              :options="vendedores"
              placeholder="Seleccione..."
              label="descripcion"
              id="vendedor"
            ></v-select>
            <label for="vendedor">Vendedor</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker
              id="fecha"
              :disabled="!puedeRegistrarFecha"
              v-model="form.fecha"
              locale="es"
              no-label
              button-now-translation="Ahora"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="YYYY-MM-DD HH:mm:ss"
              label="Seleccione fecha..."
            />
            <label>Fecha</label>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
export default {
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    tiposGastos: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    puedeRegistrarFecha: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          valor: "",
          detalle: "",
          bodega_id: "",
          tipo_gasto_codigo: "",
          fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };
      },
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
      selectedBodega: null,
      selectedTipoGasto: null,
      money: money,
      personas: [],
      selectedPersona: null,
      vendedores: []
    };
  },
  methods: {
    inputVendedor: function () {
      if (this.selectedVendedor != null)
        this.form.vendedor_id = this.selectedVendedor.id;
      else 
        this.form.vendedor_id = '';
    },
    searchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.vendedores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
      xmlhttp.send();
    },
    searchPersonas: function (search, loading) {
      if (this.selectedTipoGasto != null) {
        loading(true);
        let that = this;
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
          if (
            (this.readyState == 4 && this.status == 200) ||
            this.status == 201
          ) {
            let json = JSON.parse(this.responseText);
            that.personas = json;
            loading(false);
          } else loading(false);
        };
        xmlhttp.open(
          "GET",
          url + "/search/usuarios?tipo=" + this.selectedTipoGasto.tipo_aplicacion + "&search=" + search,
          true
        );
        xmlhttp.send();
      }
    },
    inputPersona: function () {
      if (this.selectedPersona != null) {
        this.form.persona_id = this.selectedPersona.id;
      }
      else 
        this.form.persona_id = '';
    },
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    inputTipoGasto: function () {
      if (this.selectedTipoGasto != null)
      {
        this.form.tipo_gasto_codigo = this.selectedTipoGasto.codigo;
        if (this.selectedTipoGasto.tipo_aplicacion === 'V') {
          this.selectedPersona = null;
          this.form.persona_id = '';
        }
        else {
          this.selectedVendedor = null;
          this.form.vendedor_id = '';
        }
      }
      else this.form.tipo_gasto_codigo = "";
    },
    guardar: function () {
      swal({
        title: "¿Desea almacenar los datos del gasto?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/gastos-oficina";
          axios
            .post(urlRequest, this.form)
            .then(() => {
              swal(
                "El gasto fue almacenado exitósamente.",
                "Realizado",
                "success"
              );
              this.$emit("saved");
            })

            .catch(({ response }) => {
              const status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
              }
              if (status == 409) {
                this.errores = response.data.errors;
                swal("La caja ya está cerrada.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
  mounted: function () {
    if (this.bodegas.length === 1) {
      this.selectedBodega = this.bodegas[0];
      this.inputBodega();
    }
    if (this.tiposGastos.length === 1) {
      this.selectedTipoGasto = this.tiposGastos[0];
      this.inputTipoGasto();
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/administrativo/GastoOficina.vue